import { IItemTagsClient } from './IItemTagsClient';
import { ItemTagsClientApi } from './itemTagsClientApi';
import { ItemTagsClientMocked } from './itemTagsClientMocked';

export * from './IItemTagsClient';
export * from './itemTagTypes';

// Keep Item Tags aligned with other production-ready modules.
// Flip this only when intentionally isolating the UI from the backend.
const USE_ITEM_TAGS_MOCK_DATA = false;

export const itemTagsClient: IItemTagsClient = USE_ITEM_TAGS_MOCK_DATA
  ? new ItemTagsClientMocked()
  : new ItemTagsClientApi();
